import React from 'react';
import { useAnalyticsUpdate } from './use-analytics-update';
import { useProductStateAnalytics } from './product-state-analytics';
var RegisterAnalytics = function RegisterAnalytics(_ref) {
  var productState = _ref.productState,
    preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    children = _ref.children;
  useAnalyticsUpdate(productState);
  useProductStateAnalytics(productState, preQueryItems, postQueryItems);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default RegisterAnalytics;